export const host = "https://shrouded-cliffs-54770.herokuapp.com";
//export const host = "http://localhost:3002";

export const registerRoute = `${host}/api/auth/register`;

export const loginRoute = `${host}/api/auth/login`;

export const EditUserRoute = `${host}/api/auth/edituser`;

export const setAvatarRoute = `${host}/api/auth/setavatar`;

export const searchedUsersRoute = `${host}/api/auth/searchusers`;

export const allUsersRoute = `${host}/api/auth/allusers`;

export const getFriendsRoute = `${host}/api/auth/getfriends`;

export const setFriendRoute = `${host}/api/auth/setfriend`;

export const sendMessageRoute = `${host}/api/messages/addmessage`;

export const getAllMessagesRoute = `${host}/api/messages/getMessages`;

export const deleteFriendRoute = `${host}/api/auth/deletefriend`;
